import { TechDocPage } from '../containers/pages';
import { ALLETRAMP_VIDEO_URL } from '../constants';
const softwareConfigPath = '/software-config/';
export const powerupInit = [
  {
    path: `${softwareConfigPath}`,
    menuText: 'softwareConfig',
    exact: true,
    redirectTo: `${softwareConfigPath}arrayDiscovery`,
    submenuItems: [
      {
        path: `${softwareConfigPath}arrayDiscovery`,
        menuText: 'arrayDiscovery',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRAMP_VIDEO_URL.DISCOVER_ARRAY,
        },
      },
      {
        path: `${softwareConfigPath}connectArray`,
        menuText: 'connectArray',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRAMP_VIDEO_URL.CONNECT_ARRAY,
        },
      },
      {
        path: `${softwareConfigPath}arraySetup`,
        menuText: 'arraySetup',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRAMP_VIDEO_URL.SETUP_ARRAY,
        },
      },
      {
        path: `${softwareConfigPath}completeSetup`,
        menuText: 'setupComplete',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
    ],
  },
];
